import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { Guid, TermSheet } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useDataRoomTermSheetsQuery(
	dealGuid?: Guid | undefined,
	options?: Omit<UseQueryOptions<TermSheet[], unknown, TermSheet[], any>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.TermSheets.ExistingTerms(dealGuid),
		() => AxiosUtils.getResponseData<TermSheet[]>(api.get(CerebroApiEndpoints.TermSheets.ExistingTerms(dealGuid))),
		options
	);
}
